import { z } from 'zod';

export const SHIPMENT_TYPE_OPTIONS = ['LTL', 'FTL', 'LCL', 'FCL'] as const;

export const CARTON_SIZE_OPTIONS = [
  'Standard1',
  'Standard2',
  'Standard3',
  'Standard4',
  'Custom',
] as const;

export const headerSaveSchema = z.object({
  port_of_loading: z.string().nullable().optional(),
  port_of_entry: z.string().nullable().optional(),
  shipment_type: z.enum(SHIPMENT_TYPE_OPTIONS).nullable().optional(),
  trailer_number: z.string().nullable().optional(),
  bol_number: z.string().nullable().optional(),
  carrier_name: z.string().nullable().optional(),
  carrier_scac: z.string().nullable().optional(),
  seal_number: z.string().nullable().optional(),
  ship_date: z.string().nullable().optional(),
});

export const skuConfigurationSchema = z.object({
  id: z.uuid(),
  actual_quantity: z.number().int().nullable().optional(),
  items_per_carton: z.number().int().nullable().optional(),
  carton_size: z.enum(CARTON_SIZE_OPTIONS).nullable().optional(),
  carton_weight: z.number().nullable().optional(),
  carton_length: z.number().nullable().optional(),
  carton_width: z.number().nullable().optional(),
  carton_height: z.number().nullable().optional(),
  tare_weight: z.number().nullable().optional(),
});

export const asnSaveSchema = z.object({
  header: headerSaveSchema.optional(),
  sku_configurations: z.array(skuConfigurationSchema).optional(),
});

export type HeaderSaveFormData = z.infer<typeof headerSaveSchema>;
export type SkuConfigurationFormData = z.infer<typeof skuConfigurationSchema>;
export type AsnSaveFormData = z.infer<typeof asnSaveSchema>;

export const headerSubmitSchema = headerSaveSchema
  .refine((data) => !!data.shipment_type, {
    message: 'Shipment Type is required',
    path: ['shipment_type'],
  })
  .refine((data) => !!data.trailer_number, {
    message: 'Trailer/Container is required',
    path: ['trailer_number'],
  })
  .refine(
    (data) => {
      if (data.shipment_type === 'FCL' || data.shipment_type === 'FTL') {
        return !!data.seal_number;
      }
      return true;
    },
    {
      message: 'Seal is required for FCL/FTL shipments',
      path: ['seal_number'],
    },
  );

export const asnSubmitSchema = z.object({
  header: headerSubmitSchema,
  sku_configurations: z.array(skuConfigurationSchema).optional(),
});

export type HeaderSubmitFormData = z.infer<typeof headerSubmitSchema>;
export type AsnSubmitFormData = z.infer<typeof asnSubmitSchema>;
